// extracted by mini-css-extract-plugin
export default {"own":"CalendarBlock_own__rZdxu"};